
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Login from './pages/Login';
import VideoRecording from './pages/VideoRecording';
import VideoWallPage from './pages/VideoWallPage';
import MerchantProfile from './pages/MerchantProfile';
import MerchantListing from './pages/MerchantListing';
import NotFound from './pages/NotFound';
import { initializeStorage } from './lib/storageUtils';
import { Toaster } from 'sonner';

function App() {
  useEffect(() => {
    // Initialize storage buckets when app starts
    initializeStorage();
  }, []);

  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="profile" element={<Profile />} />
          <Route path="login" element={<Login />} />
          <Route path="wall" element={<VideoWallPage />} />
          <Route path="record" element={<VideoRecording />} />
          <Route path="merchant/:id" element={<MerchantProfile />} />
          <Route path="merchants" element={<MerchantListing />} />
          <Route path="merchant/:merchantId/record" element={<VideoRecording />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
